// extracted by mini-css-extract-plugin
export default {"container":"timings_container__gmotm","heading":"timings_heading__o900H","desc":"timings_desc__V06p4","timings":"timings_timings__ryGKP","button":"timings_button__Exej9"};